import { Fragment, useEffect, useMemo, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import TabComp from "src/components/shared/TabComp";
import useQueryParams from "src/hooks/useQueryParams";
import CustomerTable from "./customer";
import EmployeeTable from "./employee";
import { USER_TYPE, userType } from "src/constant";
import { Button, Stack } from "@mui/material";
import CustomerCreateDialog from "./customer/CustomerCreateDialog";
import useAppGlobal from "src/context/useAppGlobal";
import { Add } from "@mui/icons-material";
import useAuthGlobal from "src/context/useAuthGlobal";
import useRedirect from "src/helper/direct";
import UserCreate from "./employee/UserCreate";
import { canMutateEmployeeRows, hasFullEmployeeTabs } from "./employee/utils/employeeAccess";
import { v4 as uuid } from "uuid";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import CustomerUpdateDialog from "./customer/CustomerUpdateDialog";

const tabs = [
  { id: "AllCustomer", name: "Tất cả khách hàng" },
  { id: USER_TYPE.Customer, name: "Khách hàng cá nhân" },
  { id: USER_TYPE.Company, name: "Doanh nghiệp" },
];

export default function UserTable() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog } = useAppGlobal();
  const { userMe } = useAuthGlobal();
  const [option] = useQueryParams();
  const [sumWhouseId, setSumWHouseId] = useState();
  const [subName, setSubName] = useState("Quản lý Nhân viên");
  const redirect = useRedirect();

  const handleCreateCustomer = () => {
    handleOpenDialog({
      title: "Thêm Khách hàng",
      content: <CustomerCreateDialog key={uuid()} />,
      size: "md",
    });
  };

  const handleCreateEmployee = () => {
    handleOpenDialog({
      title: "Tạo nhân viên",
      size: "md",
      content: <UserCreate key={uuid()} />,
    });
  };

  const isFullEmployeeTabs = useMemo(() => hasFullEmployeeTabs(userMe?.role?.code), [userMe?.role?.code]);

  const canManageEmployees = useMemo(() => canMutateEmployeeRows(userMe?.role?.code), [userMe?.role?.code]);
  const canCreateEmployee = permissionCheck(
    option?.tab === USER_TYPE.Sales
      ? [PERMISSIONS.CREATE_SALES_ALL, PERMISSIONS.CREATE_SALES_OWN]
      : option?.tab === USER_TYPE.SalesChannel
        ? [PERMISSIONS.CREATE_USER_ALL, PERMISSIONS.CREATE_USER_OWN, PERMISSIONS.CREATE_SALES_ALL, PERMISSIONS.CREATE_SALES_OWN]
        : [PERMISSIONS.CREATE_USER_ALL, PERMISSIONS.CREATE_USER_OWN],
  );

  const tabsEmployee = useMemo(() => {
    if (isFullEmployeeTabs) {
      return [
        { id: USER_TYPE.SalesChannel, name: "Tất cả nhân viên" },
        { id: USER_TYPE.Staff, name: "Nhân viên Kho/Kế toán" },
        { id: USER_TYPE.Sales, name: "Nhân viên Kinh doanh" },
      ];
    }
    return [{ id: USER_TYPE.Sales, name: "Nhân viên Kinh doanh" }];
  }, [isFullEmployeeTabs]);

  const isCustomerTab = useMemo(() => {
    return ["AllCustomer", USER_TYPE.Company, USER_TYPE.Customer].includes(option?.tab);
  }, [option?.tab]);

  useEffect(() => {
    if (userMe?.type === userType.sales && !isCustomerTab) {
      redirect("/home");
      return;
    }
    if (!isFullEmployeeTabs && !isCustomerTab && option?.tab !== USER_TYPE.Sales) {
      redirect("/user?tab=Sales");
    }
  }, [redirect, userMe?.type, isCustomerTab, isFullEmployeeTabs, option?.tab]);

  useEffect(() => {
    if (!isCustomerTab) {
      setSubName("Quản lý Nhân viên");
    } else {
      setSubName("Quản lý Khách hàng");
    }
  }, [isFullEmployeeTabs, isCustomerTab]);

  return (
    <Fragment>
      <PageHeader
        name="Quản lý Người Dùng"
        subName={subName}
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />
      <Stack
        gap={1.5}
        my={1.5}
      >
        {isCustomerTab ? (
          <Button
            disabled={!permissionCheck([PERMISSIONS.CREATE_CUSTOMER])}
            startIcon={<Add />}
            sx={{
              whiteSpace: "nowrap",
              width: "220px",
            }}
            onClick={handleCreateCustomer}
            variant="contained"
          >
            Thêm khách hàng
          </Button>
        ) : (
          canCreateEmployee &&
          canManageEmployees && (
            <Button
              startIcon={<Add />}
              sx={{
                whiteSpace: "nowrap",
                width: "220px",
              }}
              onClick={handleCreateEmployee}
              variant="contained"
            >
              Thêm nhân viên
            </Button>
          )
        )}
        <TabComp tabs={[USER_TYPE.SalesChannel, USER_TYPE.Sales, USER_TYPE.Staff]?.includes(option?.tab) ? tabsEmployee : tabs} />
      </Stack>

      {[USER_TYPE.SalesChannel, USER_TYPE.Sales, USER_TYPE.Staff]?.includes(option?.tab) && (
        <EmployeeTable
          headerWarehouseId={sumWhouseId}
          userWarehouseId={userMe?.currentWarehouse?._id}
        />
      )}

      {isCustomerTab && <CustomerTable />}
    </Fragment>
  );
}
